import axios from '../../utils/axios';
import CRUD from './crud'

const managers = new CRUD('managers', 'superior-judge')

export default Object.assign(
    managers,
    {
        reducers: {
            ...managers.reducers
        },


    }
)
